import { createRouter, createWebHistory } from 'vue-router'
import { ElMessage } from 'element-plus'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/meter-reading',
    name: 'MeterReading',
    component: () => import('@/views/public/MeterReadingSubmit.vue'),
    meta: { title: '手机抄表录入', public: true }
  },
  {
    path: '/patrol-checkin',
    name: 'PatrolCheckin',
    component: () => import('@/views/public/PatrolCheckin.vue'),
    meta: { title: '巡更打点', public: true }
  },
  {
    path: '/',
    component: () => import('@/layout/Layout.vue'),
    redirect: (to) => {
      // 根据用户角色重定向到对应首页
      const userRole = parseInt(localStorage.getItem('userRole')) || 0
      if (userRole === 2) {
        return '/products' // 商户跳转到商品管理
      }
      if (userRole === 3) return '/patrol'
      if (userRole === 4) return '/feedback'
      if (userRole === 5 || userRole === 6) return '/bills'
      return '/dashboard' // 管理员跳转到仪表盘
    },
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { title: '首页', icon: 'House', roles: [1] }
      },
      {
        path: '/users',
        name: 'Users',
        component: () => import('@/views/users/UserList.vue'),
        meta: { title: '业主管理', icon: 'User', roles: [1], userRoleFilter: 0 }
      },
      {
        path: '/system-users',
        name: 'SystemUsers',
        component: () => import('@/views/users/UserList.vue'),
        meta: { title: '用户管理', icon: 'User', roles: [1], menuGroup: 'system-settings', userRoleFilter: -1 }
      },
      {
        path: '/houses',
        name: 'Houses',
        component: () => import('@/views/houses/HouseList.vue'),
        meta: { title: '房产资料', icon: 'OfficeBuilding', roles: [1] }
      },
      {
        path: '/house-listings',
        name: 'HouseListings',
        component: () => import('@/views/houseListings/HouseListingList.vue'),
        meta: { title: '租售信息', icon: 'HomeFilled', roles: [1] }
      },
      {
        path: '/products',
        name: 'Products',
        component: () => import('@/views/products/ProductList.vue'),
        meta: { title: '商品管理', icon: 'ShoppingBag', roles: [1, 2] }
      },
      {
        path: '/orders',
        name: 'Orders',
        component: () => import('@/views/orders/OrderList.vue'),
        meta: { title: '订单管理', icon: 'Document', roles: [1, 2] }
      },
      {
        path: '/bills',
        name: 'Bills',
        component: () => import('@/views/bills/BillList.vue'),
        meta: { title: '收费管理', icon: 'Money', roles: [1, 5, 6] }
      },
      {
        path: '/fee-management',
        name: 'FeeManagement',
        component: () => import('@/views/fees/FeeEntryList.vue'),
        meta: { title: '水费抄表核验', icon: 'Coin', roles: [1, 5, 6] }
      },
      {
        path: '/system-settings',
        name: 'SystemSettings',
        component: () => import('@/views/settings/SystemSettings.vue'),
        meta: { title: '费用结算设置', icon: 'Setting', roles: [1], menuGroup: 'system-settings' }
      },
      {
        path: '/sms-template-settings',
        name: 'SmsTemplateSettings',
        component: () => import('@/views/settings/SmsTemplateSettings.vue'),
        meta: { title: '短信模板管理', icon: 'Message', roles: [1], menuGroup: 'system-settings' }
      },
      {
        path: '/sms-gateway-settings',
        name: 'SmsGatewaySettings',
        component: () => import('@/views/settings/SmsGatewaySettings.vue'),
        meta: { title: '短信网关配置', icon: 'Connection', roles: [1], menuGroup: 'system-settings' }
      },
      {
        path: '/print-template-settings',
        name: 'PrintTemplateSettings',
        component: () => import('@/views/settings/PrintTemplateSettings.vue'),
        meta: { title: '收费单模板', icon: 'Printer', roles: [1], menuGroup: 'system-settings' }
      },
      {
        path: '/mall-operation-settings',
        name: 'MallOperationSettings',
        component: () => import('@/views/settings/MallOperationSettings.vue'),
        meta: { title: '步行街运营', icon: 'ShoppingCart', roles: [1], menuGroup: 'system-settings' }
      },
      {
        path: '/asset-type-fee-settings',
        name: 'AssetTypeFeeSettings',
        component: () => import('@/views/settings/AssetTypeFeeSettings.vue'),
        meta: { title: '资产类型费用设置', icon: 'PriceTag', roles: [1], menuGroup: 'system-settings' }
      },
      {
        path: '/bill-type-settings',
        name: 'BillTypeSettings',
        component: () => import('@/views/settings/BillTypeSettings.vue'),
        meta: { title: '收费项目管理', icon: 'Tickets', roles: [1], menuGroup: 'system-settings' }
      },
      {
        path: '/asset-type-settings',
        name: 'AssetTypeSettings',
        component: () => import('@/views/settings/AssetTypeSettings.vue'),
        meta: { title: '资产类型管理', icon: 'OfficeBuilding', roles: [1], menuGroup: 'system-settings' }
      },
      {
        path: '/meter-unit-price-settings',
        name: 'MeterUnitPriceSettings',
        component: () => import('@/views/settings/MeterUnitPriceSettings.vue'),
        meta: { title: '抄表单价设置', icon: 'Odometer', roles: [1], menuGroup: 'system-settings' }
      },
      {
        path: '/service-content-settings',
        name: 'ServiceContentSettings',
        component: () => import('@/views/settings/ServiceContentSettings.vue'),
        meta: { title: '服务信息设置', icon: 'Phone', roles: [1], menuGroup: 'system-settings' }
      },
      {
        path: '/feedback',
        name: 'Feedback',
        component: () => import('@/views/feedback/FeedbackList.vue'),
        meta: { title: '反馈管理', icon: 'ChatDotSquare', roles: [1, 4] }
      },
      {
        path: '/announcements',
        name: 'Announcements',
        component: () => import('@/views/announcements/AnnouncementList.vue'),
        meta: { title: '公告管理', icon: 'Bell', roles: [1,2] }
      },
      {
        path: '/point-rules',
        name: 'PointRules',
        component: () => import('@/views/points/PointRuleList.vue'),
        meta: { title: '积分规则', icon: 'Star', roles: [1] }
      },
      {
        path: '/user-points',
        name: 'UserPoints',
        component: () => import('@/views/points/UserPointList.vue'),
        meta: { title: '用户积分', icon: 'Trophy', roles: [1] }
      },
      {
        path: '/visitor-passes',
        name: 'VisitorPasses',
        component: () => import('@/views/visitor/VisitorPassList.vue'),
        meta: { title: '访客通行证', icon: 'Tickets', roles: [1, 2] }
      },
      {
        path: '/patrol',
        name: 'Patrol',
        component: () => import('@/views/patrol/PatrolList.vue'),
        meta: { title: '巡更管理', icon: 'Location', roles: [1, 3] }
      },
      {
        path: '/report-repair',
        name: 'ReportRepair',
        component: () => import('@/views/feedback/RepairReport.vue'),
        meta: { title: '上报维修', icon: 'Tools', roles: [1, 6] }
      },
      {
        path: '/profile',
        name: 'Profile',
        component: () => import('@/views/Profile.vue'),
        meta: { title: '个人中心', icon: 'User', roles: [1, 2, 3, 4, 5, 6] }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const userRole = localStorage.getItem('userRole')
  const isPublicRoute = to.meta?.public === true
  
  if (to.path === '/login' || isPublicRoute) {
    next()
  } else if (!token) {
    ElMessage.error('请先登录')
    next('/login')
  } else {
    // 检查角色权限
    const requiredRoles = to.meta?.roles
    
    if (requiredRoles && requiredRoles.length > 0) {
      const currentRole = parseInt(userRole) || 0
      
      if (!requiredRoles.includes(currentRole)) {
        ElMessage.error('您没有权限访问该页面')
        // 根据用户角色重定向到允许的页面
        if (currentRole === 2) {
          // 商户重定向到商品管理
          next('/products')
        } else if (currentRole === 3) {
          next('/patrol')
        } else if (currentRole === 4) {
          next('/feedback')
        } else if (currentRole === 5 || currentRole === 6) {
          next('/bills')
        } else {
          // 其他情况重定向到登录页
          next('/login')
        }
        return
      }
    }
    
    next()
  }
})

export default router 
